import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { serchSelect, serchSelectManage } from "@/mixins/index";
import { addLoadPross, updataLoadData } from "@/api/dataAll/loadPross";
import { DATA_KEY } from 'quill';
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      arr: [{
        name: this.$t('serialNumber') + "1",
        input: "",
        lable: 0
      }, {
        name: this.$t('serialNumber') + "2",
        input: "",
        lable: 1
      }, {
        name: this.$t('serialNumber') + "3",
        input: "",
        lable: 2
      }, {
        name: this.$t('serialNumber') + "4",
        input: "",
        lable: 3
      }, {
        name: this.$t('serialNumber') + "5",
        input: "",
        lable: 4
      }, {
        name: this.$t('serialNumber') + "6",
        input: "",
        lable: 5
      }, {
        name: this.$t('serialNumber') + "7",
        input: "",
        lable: 6
      }, {
        name: this.$t('serialNumber') + "8",
        input: "",
        lable: 7
      }, {
        name: this.$t('serialNumber') + "9",
        input: "",
        lable: 8
      }, {
        name: this.$t('serialNumber') + "10",
        input: "",
        lable: 9
      }, {
        name: this.$t('serialNumber') + "11",
        input: "",
        lable: 10
      }, {
        name: this.$t('serialNumber') + "12",
        input: "",
        lable: 11
      }],
      searchData: {
        id: "",
        ad_channel: "",
        ad_placement: "",
        expand_parameter: {},
        special_product_id: ""
      },
      rules: {
        special_product_id: [{
          required: true,
          message: this.$t('selectProductLabel'),
          trigger: "blur"
        }]
      },
      ex_Val: [],
      adPlacementSingleChoice: true
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var expand_parameter, num, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!data) {
                  _context.next = 13;
                  break;
                }

                _context.next = 4;
                return _this.getAdvPlarform({
                  special_product_id: data.special_product_id
                });

              case 4:
                _this.searchData.ad_channel = data.ad_channel;
                _context.next = 7;
                return _this.advChannelchange(data.ad_channel);

              case 7:
                _this.searchData = _this.processingData(_objectSpread(_objectSpread({}, _this.searchData), data));
                expand_parameter = JSON.parse(data.expand_parameter);
                num = 0;

                for (key in expand_parameter) {
                  num++;

                  _this.ex_Val.push({
                    name: _this.$t('serialNumber') + num,
                    input: expand_parameter[key] || ""
                  });
                }

                _context.next = 14;
                break;

              case 13:
                _this.ex_Val = JSON.parse(JSON.stringify(_this.arr));

              case 14:
                _this.searchData.expand_parameter = {};

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        ad_channel: "",
        ad_placement: "",
        expand_parameter: {},
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id
      };

      if (this.rawData.game_show_type == 1) {
        this.advchannels = [];
      }

      this.advLocation = [];
      this.ex_Val = [];
      this.$refs.ruleForm.resetFields();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vaild) {
        if (vaild) {
          _this2.searchData.expand_parameter = {};
          var reqFn = _this2.searchData.id ? updataLoadData : addLoadPross;

          _this2.ex_Val.forEach(function (item, index) {
            _this2.searchData.expand_parameter[index] = item.input || "";
          });

          _this2.searchData.expand_parameter = JSON.stringify(_this2.searchData.expand_parameter);
          _this2.searchData.game_id = '';
          reqFn(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(_this2.$t('operationSuccess'));

              _this2.resetForm();

              _this2.$emit("refreshDataList", false);
            }
          });
        }
      });
    }
  }
};